import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useCart } from "../cart";
import { formatPrice } from "../utils";
import { STORE_CART_PATH } from "../../routes";


export default function OrderFormCard({ product }) {
  const { addItem, totalItems } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    addItem(product, quantity);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1800);
  };

  return (
    <aside className="store-order-card">
      <div className="store-order-head">
        <p className="store-section-kicker">Savat</p>
        <h2>Mahsulotni savatga qo'shing.</h2>
        <div className="store-order-price">
          <strong>{formatPrice(product.price)}</strong>
          {product.compare_at_price ? <span>{formatPrice(product.compare_at_price)}</span> : null}
        </div>
      </div>

      <div className="store-order-form">
        <label className="store-field">
          <span>Soni</span>
          <input
            min="1"
            onChange={(event) => setQuantity(Math.max(1, Number(event.target.value) || 1))}
            type="number"
            value={quantity}
          />
        </label>

        <button className="store-link-button store-full-button" onClick={handleAddToCart} type="button">
          Savatga qo'shish
        </button>

        <Link className="store-outline-button store-full-button" to={STORE_CART_PATH}>
          Savatga o'tish {totalItems ? `(${totalItems})` : ""}
        </Link>

        {added ? <p className="store-success-text">Mahsulot savatga qo'shildi.</p> : null}
      </div>

      <div className="store-order-note">
        <span>Mahsulot</span>
        <strong>{product.name}</strong>
      </div>
    </aside>
  );
}
